var map = {
	"./black/jieshu.png": "Rmaf",
	"./blue/jieshu.png": "eYSE",
	"./white/jieshu.png": "euWi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nOMf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/jieshu\.png$
// module id = nOMf
// module chunks = 24